import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  root: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(4),
    minHeight: "100vh"
  },
  container: {
    maxWidth: "51.2rem",
    textAlign: "center"
  },
  fontMedium: {
    fontWeight: theme.typography.fontWeightMedium
  },
  mb16: {
    marginBottom: "1.6rem"
  },
  mb48: {
    marginBottom: "4.8rem"
  }
}));
